import type { Feature } from '@luna/gatekeeper';

export const displayPin: Feature = {
    enabled: false,
    _description: 'Displays display pin card in the card services list',
};

export const displayPinEncryption: Feature = {
    enabled: false,
    _description: 'Enables new JWE secured info encryption',
};
